import api from '../config/api';

import { formatErrorResponse } from '../utils/response';

export async function getRolePermissions() {
  const response = await api.get('/role_permissions');
  if (response.ok) {
    return {
      ok: true,
      permissions: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function updateRolePermissions(type, permissions) {
  const response = await api.patch('/role_permissions', { [type]: permissions });
  if (response.ok) {
    return {
      ok: true,
      permissions: response.data,
    };
  }
  return formatErrorResponse(response);
}



// WEBPACK FOOTER //
// ./src/services/RoleService.js